import React, { useMemo } from 'react';
import { panelsAtom } from '../atoms';
import { useAtomValue } from 'jotai';
import Empty from '@images/layout/empty.svg';
import { Focus, ZenWrapper } from './styled';

function ZenPanel() {
  const panels = useAtomValue(panelsAtom);

  const zenMode = useMemo(() => {
    return Object.values(panels).every((x) => !x);
  }, [panels]);

  return zenMode ? (
    <ZenWrapper>
      <Focus>
        <Empty />
      </Focus>
    </ZenWrapper>
  ) : null;
}

export default ZenPanel;
